 // import Swiper JS
 import Swiper, {
   Autoplay,
   Pagination
 } from 'swiper';
 // import Swiper styles
 import 'swiper/css';
 import 'swiper/css/pagination';


 export function initTimeline() {
   if (window.acf) {
     window.acf.addAction(
       'render_block_preview/type=timeline',
       timeline
     );
   }
 }

 export function timeline() {

   let timeline = document.querySelector('.timeline-container');
   if (!timeline) return;

   let timelineInner = timeline.querySelector('.timeline-inner');
   let dates = timeline.querySelectorAll('.date');
   dates = Array.prototype.slice.call(dates);

   document.querySelector('.timeline-pagination .next').addEventListener('click', (e) => {
     let active = timeline.querySelector('.date.active');

     if (typeof dates[dates.indexOf(active) + 1] === 'undefined')
       return false;

     let nextDate = dates[dates.indexOf(active) + 1];
     let offset = nextDate.offsetTop;
     timelineInner.style.transform = 'translateY(-' + offset + 'px)';
     active.classList.remove('active');
     nextDate.classList.add('active');
   });

   document.querySelector('.timeline-pagination .prev').addEventListener('click', (e) => {
     let active = timeline.querySelector('.date.active');

     if (typeof dates[dates.indexOf(active) - 1] === 'undefined')
       return false;

     let nextDate = dates[dates.indexOf(active) - 1];
     let offset = nextDate.offsetTop;
     timelineInner.style.transform = 'translateY(-' + offset + 'px)';
     active.classList.remove('active');
     nextDate.classList.add('active');
   });

   // Debounce
   function debounce(func, time) {
     var time = time || 100; // 100 by default if no param
     var timer;
     return function (event) {
       if (timer) clearTimeout(timer);
       timer = setTimeout(func, time, event);
     };
   }

   // Function with stuff to execute
   function resizeContent() {
     let active = timeline.querySelector('.date.active');
     let offset = active.offsetTop;
     timelineInner.style.transform = 'translateY(-' + offset + 'px)';
   }
   window.addEventListener('resize', debounce(resizeContent, 150));

 }
